import { AgxButton, AgxModal, AgxRow, AgxSpacer, AgxTypography, Icon_AlertCircleOutline } from '@urbanx/agx.ui-components2'
import { RexDisconnectedModalFields, RexDisconnectedModalFieldValue } from './RexDataUpdateHelper'

interface RexDisconnectedModalProps {
  setIsDialogOpen: (isDialogOpen: boolean) => void
  changedFields: Map<RexDisconnectedModalFields, RexDisconnectedModalFieldValue>
}

export const RexDisconnectedModal = ({ setIsDialogOpen, changedFields }: RexDisconnectedModalProps) => {

  const modalContent = (
    <>
      <AgxRow
        id="rex-disconnected-modal-content"
        gap="spacing-5xl"
        padding={{ top: 'md', bottom: 'md', left: 'xl', right: 'xl' }}
      >
        <AgxSpacer direction="vertical" gap="spacing-lg" fill contentAlignment="start" contentJustification="start">
          <AgxTypography id="" type="body_ui_strong" size="medium" color="var(--text-primary)">
            REX Disconnected
          </AgxTypography>
          <AgxTypography id="" type="body" size="small" color="var(--text-primary)">
            Please update in REX directly.
          </AgxTypography>
          <ul>
            {[...changedFields.entries()].map(([key, value]) => (
              <li key={key}>
                <AgxTypography id="rex-disconnected-modal-field-label" type="body" size="small" color="var(--text-primary)">
                  {!value ? key : `${key}: ${value}`}
                </AgxTypography>
              </li>
            ))}
          </ul>
        </AgxSpacer>
      </AgxRow>
    </>
  )

  return (
    <AgxModal
      titleIcon={
        <div className="modelTitleIconContainer">
          <Icon_AlertCircleOutline type={'Danger'} height={40} width={40} />
        </div>
      }
      type="single"
      variant="withoutDivider"
      maxWidth="min(90vw, 1134px)"
      setIsDialogOpen={setIsDialogOpen}
      content={modalContent}
      actionButtonContainerStyle="withDivider"
      actionButtons={
        <AgxRow justifyContent="center" gap="spacing-lg" fill>
          <AgxButton
            id="rex-disconnected-confirm-button"
            size="large"
            variant="primary"
            text="Confirm"
            stretch
            onClick={() => {
              setIsDialogOpen(false)
            }}
          />
        </AgxRow>
      }
    />
  )
}

export default RexDisconnectedModal
